import { render, staticRenderFns } from "./ManagersEditor.vue?vue&type=template&id=c004c302"
import script from "./ManagersEditor.vue?vue&type=script&lang=js"
export * from "./ManagersEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports